import React from 'react';
import './NumerosEspeciales.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import NumerosEspecialesComponent from '../../Components/Admin/NumerosEspeciales/NumerosEspeciales';

export default function NumerosEspeciales() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <NumerosEspecialesComponent />
                </div>
            </section>
        </div>
    );
}
